import type { Menu } from '#/global'

const menus: Menu.recordRaw = {
  meta: {
    title: '系统管理',
    icon: 'i-ep:setting',
  },
  children: [
    {
      path: '/system/admin',
      meta: {
        title: '管理员管理',
        icon: 'i-ep:user-filled',
      },
    },
    {
      path: '/system/role',
      meta: {
        title: '角色管理',
        icon: 'i-ep:avatar',
      },
    },
    {
      path: '/system/menu',
      meta: {
        title: '菜单管理',
        icon: 'i-ep:menu',
      },
    },
    {
      path: '/system/permission',
      meta: {
        title: '权限分配',
        icon: 'i-ep:key',
      },
    },
    {
      path: '/system/module',
      meta: {
        title: '系统模块管理',
        icon: 'i-ep:grid',
      },
    },
    {
      path: '/system/workflow',
      meta: {
        title: '审批流管理',
        icon: 'i-ep:connection',
      },
    },
    {
      path: '/system/settings/site-info',
      meta: {
        title: '站点设置',
        icon: 'i-ep:info-filled',
      },
    },
    {
      path: '/system/settings/system-config',
      meta: {
        title: '系统配置',
        icon: 'i-ep:setting',
      },
    },
    {
      path: '/system/settings/dictionary',
      meta: {
        title: '系统字典',
        icon: 'i-ep:collection',
      },
    },
  ],
}

export default menus
